import { AnalyticsAdapter, AnalyticsOccurrence } from 'components/shared/analytics/analytics-types.js'

const adapters: Set<AnalyticsAdapter> = new Set()

export const registerAnalyticsAdapter = (adapter: AnalyticsAdapter | null): void => {
  if (adapter) adapters.add(adapter)
}

export const resetAnalyticsAdapters = (): void => {
  adapters.clear()
}

export const track = (occurrence: AnalyticsOccurrence): void => {
  adapters.forEach(adapter => {
    try {
      adapter.handle(occurrence)
    } catch (error) {
      console.error(`Analytics adapter '${adapter.name}' failed to handle '${occurrence.type}'`, error)
    }
  })
}
